import styled from 'styled-components';
import { dot } from 'styles/Colors';

export const DotsWrapper = styled.div`
  display: flex;
`;

export const DotWrapper = styled.div`
  margin-right: 9px;
  content: '';
  width: 8px;
  height: 8px;
  border: 1px solid ${dot};
  border-radius: 25px;
  &.active {
    background: ${dot};
  }
  &:last-of-type {
    margin-right: 0px;
  }
`;
